import axios, { AxiosResponse } from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';

export const resetDefaultFishGroupProfiles = async (owner: OwnerType, fishGroupId: string[], index: number): Promise<number> => {
  await axios.all(
    fishGroupId.map((fishGroupId) =>
      axios
        .delete<AxiosResponse>(`/ewosapi/v2/planandprognosis/default-profile/${owner}/${fishGroupId}`)

        .then((resp) => resp.data)
    )
  );

  return index;
};
